import React from "react";
import MobileHeader from "../../layout/MobileHeader";
import Container from "../../layout/Container";
import Icon from "../../components/Icon";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import EpujaCard from "../../components/cards/EpujaCard";

import Hero from "../../assets/images/hero.png";
import OfferCard from "../../components/cards/OfferCard";
import MobileHeaderSearch from "../../components/MobileHeaderSearch";

import headerImg from '../../assets/images/topLocationHeader.png'
import { convertTo12HourFormat, dateFormat } from "../../utils";
import { Link } from "react-router-dom";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ImageSlider from "../../components/elements/ImageSlider";
import { SwiperSlide } from "swiper/react";
import EpujaForm from "../Epuja/EpujaForm";



const EpujaDetails = ({ details = {}, list = [] }) => {
  return (
    <>
      <MobileHeader placeholder="saerch for puja/hawan" himage={headerImg} height={'237px'}  >
          <MobileHeaderSearch placeholder="Search E puja"/>
      </MobileHeader>
      <Container>
        <section className="mobile-top-space">
          <h3 className="my-3 text-center custom-text-color top-heading">
            Find Your Remedy For Peace & Prosperety
          </h3>
          <div className="row">
            <div className="col-lg-8 col-md-12 p-0">
              <ImageSlider>
                {
                  details?.files?.map((file, i) =>
                    <SwiperSlide key={i}>
                      <div style={{ height: "250px" }}>
                        <img src={file.Url} className="w-100 h-100 image-cover rounded-3" />
                      </div>
                    </SwiperSlide>
                  )
                }
              </ImageSlider>
            </div>

            <div className="col-md-12">
              <p className="custom-text-color my-2 fs-9">
                <Icon icon={faCalendarAlt} className="me-2" />{ dateFormat(details.ePujaDate) },
                { details.day } (upto { details.end_at && convertTo12HourFormat( details.end_at )})
              </p>
              <h3 className="text-saffron mb-4 mt-3 fs-5">
              { details.title }
              </h3>
              <p className="mb-3">
              { details.description }
              </p>
              
            </div>
            <div className="col-lg-4 col-md-12 p-0">
              {/* <div className="card rounded-4 p-4  m-2">
                <div className="row">
                  <div className="col-6 p-0">
                    <div className="m-2">
                      <label className="mb-1 bold">First Name</label>
                      <input
                        className="input-2"
                        placeholder="Enter First Name"
                      />
                    </div>
                  </div>
                  <div className="col-6 p-0">
                    <div className="m-2">
                      <label className="mb-1 bold">Last Name</label>
                      <input
                        className="input-2"
                        placeholder="Enter Last Name"
                      />
                    </div>
                  </div>

                  <div className="col-12 p-0">
                    <div className="m-2">
                      <label className="mb-1 bold">Gotra</label>
                      <input className="input-2" placeholder="Person's Gotra" />
                    </div>
                  </div>

                  <div className="col-12 p-0">
                    <div className="m-2">
                      <label className="mb-1 bold">Note</label>
                      <input className="input-2" placeholder="Write Note" />
                    </div>
                  </div>

                  <div className="col-6 p-0">
                    <div className="m-2">
                      <label className="mb-1 bold">Date</label>

                      <DatePicker 
                        className="input-2"
                        placeholderText="Date"
                      />
                    </div>
                  </div>

                  <div className="col-6 p-0">
                    <div className="m-2">
                      <label className="mb-1 bold">City</label>
                      <select
                        className="input-2"
                        placeholder="Write Note"
                      >
                        <option>Select City </option>
                        <option>Noida</option>
                        <option>Delhi</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-6">
                    <p className="bold fs-5">Price</p>
                  </div>
                  <div className="col-6">
                    <p className="bold fs-5 text-saffron text-end">₹1200</p>
                  </div>
                </div>
                <button className="primary-btn my-3">Book Now</button>
              </div> */}
              <EpujaForm details={details} />
            </div>
          </div>

          <h3 className="custom-text-color my-5">Similar Puja Havan</h3>

          <div className="row flex-nowrap scrollbar-hidden">
            {
              list?.map(( ls, i ) => 
                <div className="col-lg-6" key={i}>
                  <EpujaCard data={ls} />
                </div>
              )
            }
          </div>

          <div className="row  mx-0 my-5 ">
            <div className="top-heading mb-2">
              Best offers for you
            </div>
          <ul className="list-unstyled d-flex offers-card-list-mobile  m-0 mobileScrollBar">
            <li className="m-2">
              <div className="bg-dark rounded offers-card-container">
                <OfferCard data={"Get upto 15% off on your First Booking"} />
              </div>
            </li>

            <li className="m-2">
              <div className="bg-dark rounded offers-card-container">
                <OfferCard data={"Budget Friendly Homestays"} />
              </div>
            </li>
          </ul>
          <Link to={'/offers'} className="d-flex justify-content-center mt-2">
            <button className="secondary-btn w-75">View all offers</button>
          </Link>
        </div>
        </section>
      </Container>
    </>
  );
};

export default EpujaDetails;
